const ARCHIVE_CONTENT_FOLDERS_SUCCESS = "content-folders::archive::success";

const CREATE_CONTENT_FOLDER = "content-folder::create";
const CREATE_CONTENT_FOLDER_ERROR = "content-folder::create::error";
const CREATE_CONTENT_FOLDER_SUCCESS = "content-folder::create::success";

const LOAD_CONTENT_FOLDERS = "content-folders::load-all::success";
const LOAD_CONTENT_FOLDERS_FAILURE = "content-folders::load-all::failure";

const MOVE_TO_CONTENT_FOLDER = "content-folder::move";
const MOVE_TO_CONTENT_FOLDER_ERROR = "content-folder::move::error";
const MOVE_TO_CONTENT_FOLDER_SUCCESS = "content-folder::move::success";

function createContentFolderAction(folderName) {
  return {
    payload: {
      serviceArgs: [folderName],
    },
    type: CREATE_CONTENT_FOLDER,
  };
}

function moveToContentFolderAction(payload, successMessage = "") {
  const { id, items } = payload;
  return {
    payload: {
      successMessage,
      serviceArgs: [id, items],
    },
    type: MOVE_TO_CONTENT_FOLDER,
  };
}

export {
  ARCHIVE_CONTENT_FOLDERS_SUCCESS,
  CREATE_CONTENT_FOLDER,
  CREATE_CONTENT_FOLDER_ERROR,
  CREATE_CONTENT_FOLDER_SUCCESS,
  createContentFolderAction,
  LOAD_CONTENT_FOLDERS,
  LOAD_CONTENT_FOLDERS_FAILURE,
  MOVE_TO_CONTENT_FOLDER,
  MOVE_TO_CONTENT_FOLDER_ERROR,
  MOVE_TO_CONTENT_FOLDER_SUCCESS,
  moveToContentFolderAction,
};
